import { render, staticRenderFns } from "./Releases.vue?vue&type=template&id=4d40ead2&scoped=true"
import script from "./Releases.vue?vue&type=script&lang=ts"
export * from "./Releases.vue?vue&type=script&lang=ts"
import style0 from "./Releases.vue?vue&type=style&index=0&id=4d40ead2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d40ead2",
  null
  
)

export default component.exports